var _path, _path2, _path3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 98,
    viewBox: "0 0 102 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 9,
    width: 80,
    height: 80
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 86.26V12H88.26V86.26H14Z",
    fill: "white",
    stroke: "#001B4D",
    strokeWidth: 4.74
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3499 40.8501L46.7878 57.4122L38.9034 49.528",
    stroke: "#001B4D",
    strokeWidth: 4.74,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 17,
    width: 64,
    height: 64
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3584 78.3616V19.9016H21.8984V78.3616H80.3584Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4.74
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.2597 49.1316C80.2597 65.2203 67.2172 78.2628 51.1284 78.2628C35.0397 78.2628 21.9972 65.2203 21.9972 49.1316C21.9972 33.0428 35.0397 20.0003 51.1284 20.0003C67.2172 20.0003 80.2597 33.0428 80.2597 49.1316Z",
    stroke: "#001B4D",
    strokeWidth: 4.74,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/CheckMark.91ea08ed535c910e47f625547f87c99f.svg";
export { ForwardRef as ReactComponent };